import { Component, OnInit, Input } from '@angular/core';
import { CourseRegistrationsService } from '../course-registrations.service';

@Component({
    selector: 'app-course-registrations',
    templateUrl: './course-registrations.component.html',
    styleUrls: ['./course-registrations.component.scss']
})
export class CourseRegistrationsComponent implements OnInit {
    @Input() display;

    constructor(private courseRegistrationsService: CourseRegistrationsService) {}

    ngOnInit(): void {
        this.get();
    }

    get(): void {
        this.courseRegistrationsService.get();
    }

    collapse(): void {
        if (this.isEditable) return;
        this.display = !this.display;
    }

    reload(): void {
        if (this.isEditable) return;
        this.get();
    }

    add(): void {
        if (this.isEditable) return;
        this.display = true;
        this.courseRegistrationsService.isAdd = true;
        this.courseRegistrationsService.isEditable = true;
    }

    get isAdd() {
        return this.courseRegistrationsService.isAdd;
    }

    get isEditable() {
        return this.courseRegistrationsService.isEditable;
    }

    get courseRegistrations() {
        return this.courseRegistrationsService.courseRegistrations;
    }

    get isLoading() {
        return this.courseRegistrationsService.isLoading;
    }

    get errorMessage() {
        return this.courseRegistrationsService.errorMessage;
    }

}
